export default __webpack_public_path__ + "static/media/accessing_the_dashboard_1.f66b53e7.png";